import _classCallCheck from '/app/node_modules/babel-runtime/helpers/classCallCheck';
export var InternalServerError = function InternalServerError(data) {
    _classCallCheck(this, InternalServerError);

    var message = data.message,
        stack = data.stack;

    this.message = message || '';
    this.stack = stack || '';
};


//////////////////
// WEBPACK FOOTER
// ./src/abstractions/errors/internal-server.js
// module id = ./src/abstractions/errors/internal-server.js
// module chunks = 34